import { makeStyles } from "@material-ui/core";
import React from "react";

export function useGlobalStyle () {
    const gcls = useStyles();
    return React.useMemo(() => gcls, [gcls]);
}

const useStyles = makeStyles(theme => ({
    floatRight: {
        marginLeft: 'auto'
    }
}))